import { setSelectedMarker } from "../state/selectedMarker";

export default function selectMarker(id, autoScroll = false) {
	setSelectedMarker(!!id && [id, autoScroll]);
}
